import { RefObject, useEffect, useRef } from 'react';

type Props = {
  inputRef: RefObject<HTMLInputElement | null>;
  onBlur?: (inputValue: string) => void;
};

const useInputBlurListener = ({ inputRef, onBlur }: Props) => {
  const onBlurRef = useRef(onBlur);
  onBlurRef.current = onBlur;

  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    const handler = (e: Event) => onBlurRef.current?.((e.target as HTMLInputElement)?.value || '');
    el.addEventListener('blur', handler);
    return () => el.removeEventListener('blur', handler);
  }, [inputRef]);
};

export default useInputBlurListener;
